import request from '@/utils/request'

//根据id查询作业
export function getTaskById(query) {
	return request({
		url: '/api/task/getTaskById',
		method: 'get',
		params: query
	})
}
//查看课程作业列表
export function tasklist(data) {
	return request({
		url: '/api/userTask/ourTaskList',
		method: 'get',
		params: data
	})
}
//查看课程作业列表
export function ourAllTaskList(data) {
	return request({
		url: '/api/userTask/ourAllTaskList',
		method: 'get',
		params: data
	})
}
//根据作业id查询课程作业试题
export function taskTopic(data) {
	return request({
		url: '/api/userTask/listTopic',
		method: 'get',
		params: data
	})
}
//根据用户作业记录id查询用户试卷/作业id查询自己的试卷
export function getUserTask(data) {
	return request({
		url: '/api/userTask/getUserTask',
		method: 'get',
		params: data
	})
}
//提交作业
export function taskCommit(data) {
	return request({
		url: '/api/userTask/commit',
		method: 'post',
		data
	})
}

//我的作业
export function getOurTaskList(data) {
	return request({
		url: '/api/userTask/getOurTaskList',
		method: 'get',
		params: data
	})
}

//查询已提交的作业
export function listUserTask(data) {
	return request({
		url: '/api/userTask/getOurCommitTaskList',
		method: 'get',
		params: data
	})
}
//查询未提交的作业
export function listUserTaskUn(data) {
	return request({
		url: '/api/userTask/getOurUnCommitTaskList',
		method: 'get',
		params: data
	})
}
